export const COMMON_APPROVAL_STRINGS = {
  fee: 'Offered price',
  yourPrice: 'Your price',
  copies: 'Print run',
  reason: 'Reason',
  comment: 'Comment',
  approveAll: 'Approve all',
  confirm: 'Confirm',
  answeredCount: (answered: number, total: number) => `${answered} of ${total} ${total === 1 ? 'song' : 'songs'} answered`,
  answered: (date?: string) => (date ? `Answered on ${date}` : 'Answered'),
  approved: 'Approved',
  rejected: 'Rejected',
  counteroffered: 'Counteroffered',
  error: 'Submission failed',
  retry: 'Retry',
} as const
